 
import type { OptionProps } from 'react-select';
import type { UserAgentOption } from './userAgentCreator';

type UserAgentOptionsProps = OptionProps<UserAgentOption, false>;

const UserAgentOptions = (props: UserAgentOptionsProps) => {
  // شکل نمایش آپشن های user agent در تنظیمات خزش
  const { innerProps, innerRef } = props;
  return (
    <>
      <style>{`.customized-searchbox-option:hover{
          background-color:var(--falcon-gray-link-hover-100);
        }
        `}</style>
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          backgroundColor: props.isSelected
            ? 'var(--falcon-gray-link-hover-200)'
            : '',
          direction: 'ltr'
        }}
        className="p-2 cursor-pointer customized-searchbox-option"
      >
        <div className="fs-0 text-capitalize text-900">{props.data.label} </div>
      </div>
      {props.options[props.options.length - 1] !== props.data && (
        <div className="border border-1" style={{ width: '100%', height: 1 }} />
      )}
    </>
  );
};

export default UserAgentOptions;
